export default __webpack_public_path__ + "media/b91e56ed7129be33a86bc2049a285b378cc89f9a4310bde27eac9cd93b82ce5c.svg";